class TicketService {
  private async fetchWithAuth(url: string, options: RequestInit = {}) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Aucun token d\'authentification trouvé');

    const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return response.json();
  }

  async listTickets() {
    return this.fetchWithAuth('/tickets');
  }

  async getTicketById(id: number) {
    console.log("Fetching ticket with ID:", id);
    return this.fetchWithAuth(`/ticket/${id}`);
  }

  async listAttachments(ticketId: number) {
    return this.fetchWithAuth(`/ticket/${ticketId}/attachments`);
  }

  async listOffices() {
    return this.fetchWithAuth('/offices');
  }

  async createTicket(payload: {
    user_id: number;
    subject: string;
    content: string;
    office_id: number | string;
    attachments?: File[];
  }) {
    const { user_id, subject, content, office_id, attachments = [] } = payload;

    if (!user_id || Number.isNaN(Number(user_id))) {
      throw new Error("Identifiant d'utilisateur invalide.");
    }

    if (!subject.trim()) {
      throw new Error("Objet de ticket manquant.");
    }

    if (!content.trim()) {
      throw new Error("Contenu du ticket manquant.");
    }

    const formData = new FormData();
    formData.append('user_id', String(user_id));
    formData.append('subject', subject);
    formData.append('content', content);
    formData.append('office_id', String(office_id));

    attachments.forEach((file) => {
      formData.append('attachments[]', file);
    });

    return this.fetchWithAuth('/tickets', {
      method: 'POST',
      body: formData,
    });
  }

  async createComment(ticketId: number, payload: { comment: string; user_id: number }) {
    if (!ticketId || Number.isNaN(ticketId)) {
      throw new Error("Identifiant de ticket invalide.");
    }
    if (!payload.user_id) {
      throw new Error("Utilisateur non authentifié.");
    }

    return this.fetchWithAuth(`/ticket/${ticketId}/comments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  }

  async uploadAttachment(ticketId: number, file: File) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Aucun token d\'authentification trouvé');

    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${process.env.REACT_APP_API_URL}/ticket/${ticketId}/attachments`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });

    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return response.json();
  }

  async deleteAttachment(ticketId: number, attachmentId: number) {
    return this.fetchWithAuth(`/ticket/${ticketId}/attachments/${attachmentId}`, {
      method: 'DELETE',
    });
  }
}

export const ticketService = new TicketService();